// redesign
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import CustomReportTemplateBody from "./redesign/CustomReportTemplateBody";

const EditReportTemplate = () => {
  const { id } = useParams();

  // state
  const [layouts, setLayouts] = useState({});
  const [gridData, setGridData] = useState([]);

  return (
    <div className="mt-3 h-100">
      <div className="border p-3 h-100 d-flex flex-column">
        <CustomReportTemplateBody {...{ mode: "edit", id, layouts, setLayouts, gridData, setGridData }} />
      </div>
    </div>
  );
};

export default EditReportTemplate;
